import React from 'react';
import heroPicture from './../../assets/newheropic.png';
import './Home.css';

class Home extends React.Component {
    render() {
        const linkedin = "https://www.linkedin.com/in/sean-pourgoutzidis";

        return (
        <article id="Home" className="home">
            <div className="grid-container">
                <section>
                    <header>
                        <p>Hello I'm</p>
                        <h1>Sean <br />Pourgoutzidis</h1>
                    </header>
                    <a href={linkedin} target="_blank" rel="noreferrer">Connect with me!</a>
                </section>
                <div className="image-and-connect">
                    <img src={heroPicture} alt="Me"/>
                    
                </div>
            </div>
            <div className="nub"/>
        </article>);
    }
}

export default Home;